import { UrlParam } from './url-param.model';
import { UrlParamHash } from './url-param-hash.interface';

export class UrlParams {

    private _params:UrlParamHash = {};

    private _length:number = 0;
    public get length():number {
        return this._length;
    }

    constructor() {
        //
    }

    public add(param:UrlParam) {
        if(!this._params[param.key]){
            this._params[param.key] = param;
            this._length++;
        } else {
            throw new Error('You may only add unique keys to this model');
        }
    }

    public remove(param:UrlParam) {
        if(this._params[param.key]) {
            this._params[param.key] = null;
            delete this._params[param.key];
            this._length--;
        } else {
            throw new Error('This key does not exist for UrlParams');
        }
    }

    public toString():string {
        let urlParamsString:string = '';
        for(let key in this._params) {
            let k:string = encodeURIComponent(this._params[key].key);
            let v:string = encodeURIComponent(this._params[key].value);
            urlParamsString += k + '=' + v + '&';
        }
        if(urlParamsString.length > 1) {
            // assume at least one entry
            // trim last &
            urlParamsString = urlParamsString.substring(0, urlParamsString.length - 1);
        }
        return urlParamsString;
    }

}